/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./data-collection.css";
import { Embarques } from "../embarques/embarques";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import SelectWithFilter from "../../../../../components/SelectWithFilter/SelectWithFilter";
import { Modal, Spinner } from "react-bootstrap";

const DataCollection = ({ awbId, set_show_form }) => {
  const [statusCof, setStatusCof] = useState(false);
  const [embarque, setEmbarque] = useState(0);
  //Para habilitar o no nuevos campos👇
  const [transport, setTransport] = useState(false);
  const [address, setAddress] = useState(false);
  //Para habilitar o no nuevos campos☝
  const [loading, setLoading] = useState(true); // Estado de carga
  const [showModal, setShowModal] = useState({
    show: false,
    message: "",
  }); //para mostrar el modal de cuando se esta cargando el sqs
  const [statusSqs, setStatusSqs] = useState(null);
  const [formData, setFormData] = useState({
    fwb_id: awbId,
    cfdi_type: null,
    sucursal: null,
    bienesTranspField: [""],
    claveUnidadField: [""],
    cantidadField: [""],
    pesoEnKgField: [""],
    valorMercanciaField: [""],
    monedaField: [""],
    descripcionField: [""],
    sectorCOFEPRIS: [""],
    nombreIngredienteActivo: [""],
    nomQuimico: [""],
    denominacionGenericaProd: [""],
    denominacionDistintivaProd: [""],
    fabricante: [""],
    fechaCaducidad: [""],
    loteMedicamento: [""],
    formaFarmaceutica: [""],
    condicionesEspTransp: [""],
    registroSanitarioFolioAutorizacion: [""],
    permisoImportacion: [""],
    rfcEmisor: null,
    cveMaterialPeligrosoField: null,
    embalajeField: null,
    regimenAduanero_id: null,
    //Nuevos campos👇
    has_transport: 0,
    parteTransporte: null,
    tipoFigura: null,
    rfcFigura: null,
    numLicencia: null,
    nombreFigura: null,
    numRegIdTribFigura: null,
    residenciaFiscalFigura: null,
    has_address: 0,
    calle: null,
    numeroExterior: null,
    numeroInterior: null,
    colonia: null,
    localidad: null,
    referencia: null,
    municipio: null,
    estado: null,
    pais: null,
    codigoPostal: null,
    //nuevos campos☝
  });
  const [isDg, setIsDg] = useState(0);

  const formatSelet = (obj) => {
    const options = [];
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        options.push({
          value: key,
          label: obj[key],
        });
      }
    }
    return options;
  };

  const { handleSubmit } = useForm();

  //inofrmacion general de la guia
  const [guideData, setGuideData] = useState({
    guideInfo: {}, //Informacion de la guia cargada.
    goods: [], // Informacion de las mercancias que trae la Guia.
    merchandiseCode: {}, // clave de mercancia que viene
    figura_transporte: {}, // clave de mercancia que viene
    status_sqs: null, // define el estado en el que se encuentra la peticion en el server sqs
  });

  //catalogos
  const [catalogs, setCatalogs] = useState({
    unidad: [], //ClaveUnidad
    currency: [], //Monedas
    customs: [], //aduanas
    hazardous: [], //Material peligroso
    pharmacist: [], // farmacéutica
    conditionsSpecial: [], // condicion especial
    packaging: [], //embalaje
    stations: [], //estacion
    merchandiseKey: [], //Clave de mercancia
    cofepris: [], //Sector COFEPRIS
    pais: [], //Sector COFEPRIS
    figuraTransporte: [], //figuraTransporte
    parteTransporte: [], //parteTransporte
  });

  //opciones seleccionadas - cada uno tiene el nombre del campo al cual pertenece en el formulario
  const [currentOptios, setCurrentOptiond] = useState({
    unidad: [""], // Clave Unidad
    currency: [""], // Moneda
    customs: [""], // Regimen Aduanero
    hazardous: {}, // Clave Material Peligroso
    pharmacist: [""], // Forma Farmacéutica
    conditionsSpecial: [""], // Condiciones Especiales de Transporte
    packaging: [""], // Tipo de Embalaje
    stations: [""], // estaciones
    merchandiseKey: [""], // Clave de mercancia
    amounts: [""], // cantidad de mercancia
    weights: [""], // peso de la mercancia
    worths: [""], // valor de la mercancia
    descriptions: [""], //descripcion de la mercacia
    healthRegisters: [""], //Registro Sanitario Folio de Autorización
    importPermits: [""], //Permiso de Importación
    cemicalNames: [""], //Nombre Químico
    denominations: [""], //Denominación Genérica del Producto
    distinctiveDenominations: [""], //Denominación Distintiva del Producto
    dateExpiries: [""], // Fecha de Caducidad
    makers: [""], // Fabricante
    medicationBatches: [""], //Lote del Medicamento
    cofepris: [""], //Sector COFEPRIS
    activeIngredientName: [""], //Nombre Ingrediente Activo
    rfcEmisor: "", //RFC del Emisor
    cfdi_type: "", //Que Tipo de CFDI
    //nuevos campos👇
    has_transport: 0, //Transporte
    parteTransporte: {}, //Parte Transporte
    tipoFigura: {}, // Tipo de Figura
    rfcFigura: null, //Rfc de la figura
    numLicencia: null, //Numero de Licencia
    nombreFigura: null, //Nombre de la figura
    numRegIdTribFigura: null, //Numero de registro id Tributario
    residenciaFiscalFigura: {}, //Residencia Fiscal de la Figura
    has_address: 0, //Domicilio
    calle: null, //Calle
    numeroExterior: null, //Número Exterior
    numeroInterior: null, //Número Interior
    colonia: null, //Colonia
    localidad: null, //Localidad
    referencia: null, //Referencia
    municipio: null, //Municipio
    estado: null, //Estado
    pais: {}, //Pais
    codigoPostal: null, //Código Postal
    //nuevos campos☝
  });

  const getCatalogMerchandiseCode = async (inputValue) => {
    try {
      if (inputValue.length >= 4) {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/catalogs_cartaporte/getClaveProdServCP/${inputValue}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        setCatalogs((prevOptions) => ({
          ...prevOptions,
          merchandiseKey: response.data.data,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showDG = async (mercancia) => {
    try {
      // Si mercancia es un array (viene del SelectWithFilter)
      if (Array.isArray(mercancia)) {
        if (mercancia.length === 0) {
          setIsDg(0);
        }

        // Verificar cada mercancía para ver si es peligrosa
        let isDgFound = 0;
        for (const item of mercancia) {
          if (item && item.value) {
            const response = await axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/catalogs_cartaporte/getIsDG/${item.value}`,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
              }
            );
            if (response.data.code === 1 && response.data.is_dg === 1) {
              isDgFound = 1;
              break; // No necesitamos seguir verificando si ya encontramos una peligrosa
            }
          }
        }
        setIsDg(isDgFound);
      } else {
        // Si mercancia no es un array (viene de otra fuente)
        if (mercancia) {
          const response = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/v1/catalogs_cartaporte/getIsDG/${mercancia}`,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            }
          );
          setIsDg(
            response.data.code === 1 && response.data.is_dg === 1 ? 1 : 0
          );
        } else {
          setIsDg(0);
        }
      }
    } catch (error) {
      console.error(error);
      setIsDg(0);
    }
  };

  const handleInputChange = (inputValue) => {
    getCatalogMerchandiseCode(inputValue);
  };

  useEffect(() => {
    const USE_FAKE_RESPONSE = false;
    const fakeData = {
      code: 1,
      message: "",
      data: {
        fwb: {
          id: 1035,
          awb: "139-01473113",
          no_flight: "AM",
          origin: "MAM",
          destinaiton: "MEX",
          route: "MAMMEX",
          pieces: 4,
          weight: 105,
          date: "2025-09-09T15:30:00.000Z",
          shipper: "99999",
          shipper_name: "COMAT AEROLITORAL\r",
          consigne: "99999",
          consignee_name: "COMAT AEROLITORAL\r",
          cvd: "AGT/1110312497/1111111\r",
          rtd: null,
          its_ddx: 0,
          sucursal_id: null,
          name_archive: "HORUS_20250909_125206_PMSID83047461.txt",
          distance_calculations: 737.5,
          edited: 1,
          type: null,
          message: "Cannot read properties of null (reading 'toString')",
          timbrado_flag: null,
          fecha_timbrado: null,
          status: null,
          EsGuiaDeCredito: 1,
          TipoCambio: null,
          Nombre_Emisor: "AEROVIAS EMPRESA DE CARGO SA DE CV",
          Rfc_Emisor: "AEC1102161K3",
          Nombre_Receptor: "AEROVIAS EMPRESA DE CARGO SA DE CV",
          Rfc_Receptor: "AEC1102161K3",
          Rfc_Remitente: "AEC1102161K3",
          description: null,
          is_dg: "0",
          flag: false,
          regimenAduanero_id: null,
          status_sqs: 3,
          created_at: "2025-09-06T00:24:10.000Z",
          updated_at: "2025-09-09T12:52:12.000Z",
          deleted_at: null,
        },
        mercancias: [
          {
            id: 52061,
            fwb_id: 1035,
            mercanciasField_id: null,
            bienesTranspField: 4327,
            bienesTranspFieldSpecified: null,
            cantidadField: 1,
            cantidadFieldSpecified: null,
            cantidadTransportaField: null,
            claveSTCCField: null,
            claveSTCCFieldSpecified: null,
            claveUnidadField: 374,
            claveUnidadFieldSpecified: null,
            cveMaterialPeligrosoField: null,
            cveMaterialPeligrosoFieldSpecified: null,
            descripEmbalajeField: null,
            descripcionField: "Maquina impresora tridimensional",
            detalleMercanciaField: null,
            dimensionesField: null,
            embalajeField: null,
            embalajeFieldSpecified: null,
            fraccionArancelariaField: null,
            fraccionArancelariaFieldSpecified: null,
            materialPeligrosoField: null,
            materialPeligrosoFieldSpecified: null,
            monedaField: 100,
            monedaFieldSpecified: null,
            pesoEnKgField: 4,
            uUIDComercioExtField: null,
            unidadField: null,
            valorMercanciaField: 0.01,
            valorMercanciaFieldSpecified: null,
            sectorCofepris_id: null,
            nombreIngredienteActivo: null,
            nomQuimico: null,
            denominacionGenericaProd: null,
            denominacionDistintivaProd: null,
            fabricante: null,
            fechaCaducidad: null,
            loteMedicamento: null,
            formaFarmaceutica_id: null,
            condicionesEspTransp_id: null,
            registroSanitarioFolioAutorizacion: null,
            permisoImportacion: null,
            created_at: "2025-09-08T20:54:54.000Z",
            updated_at: "2025-09-08T20:54:54.000Z",
            deleted_at: null,
          },
          {
            id: 52062,
            fwb_id: 1035,
            mercanciasField_id: null,
            bienesTranspField: 5550,
            bienesTranspFieldSpecified: null,
            cantidadField: null,
            cantidadFieldSpecified: null,
            cantidadTransportaField: null,
            claveSTCCField: null,
            claveSTCCFieldSpecified: null,
            claveUnidadField: 374,
            claveUnidadFieldSpecified: null,
            cveMaterialPeligrosoField: null,
            cveMaterialPeligrosoFieldSpecified: null,
            descripEmbalajeField: null,
            descripcionField: "principal E190",
            detalleMercanciaField: null,
            dimensionesField: null,
            embalajeField: null,
            embalajeFieldSpecified: null,
            fraccionArancelariaField: null,
            fraccionArancelariaFieldSpecified: null,
            materialPeligrosoField: null,
            materialPeligrosoFieldSpecified: null,
            monedaField: 149,
            monedaFieldSpecified: null,
            pesoEnKgField: 9,
            uUIDComercioExtField: null,
            unidadField: null,
            valorMercanciaField: null,
            valorMercanciaFieldSpecified: null,
            sectorCofepris_id: null,
            nombreIngredienteActivo: null,
            nomQuimico: null,
            denominacionGenericaProd: null,
            denominacionDistintivaProd: null,
            fabricante: null,
            fechaCaducidad: null,
            loteMedicamento: null,
            formaFarmaceutica_id: null,
            condicionesEspTransp_id: null,
            registroSanitarioFolioAutorizacion: null,
            permisoImportacion: null,
            created_at: "2025-09-08T20:54:54.000Z",
            updated_at: "2025-09-08T20:54:54.000Z",
            deleted_at: null,
          },
          {
            id: 52063,
            fwb_id: 1035,
            mercanciasField_id: null,
            bienesTranspField: null,
            bienesTranspFieldSpecified: null,
            cantidadField: null,
            cantidadFieldSpecified: null,
            cantidadTransportaField: null,
            claveSTCCField: null,
            claveSTCCFieldSpecified: null,
            claveUnidadField: 374,
            claveUnidadFieldSpecified: null,
            cveMaterialPeligrosoField: null,
            cveMaterialPeligrosoFieldSpecified: null,
            descripEmbalajeField: null,
            descripcionField: null,
            detalleMercanciaField: null,
            dimensionesField: null,
            embalajeField: null,
            embalajeFieldSpecified: null,
            fraccionArancelariaField: null,
            fraccionArancelariaFieldSpecified: null,
            materialPeligrosoField: null,
            materialPeligrosoFieldSpecified: null,
            monedaField: 149,
            monedaFieldSpecified: null,
            pesoEnKgField: 12,
            uUIDComercioExtField: null,
            unidadField: null,
            valorMercanciaField: null,
            valorMercanciaFieldSpecified: null,
            sectorCofepris_id: null,
            nombreIngredienteActivo: null,
            nomQuimico: null,
            denominacionGenericaProd: null,
            denominacionDistintivaProd: null,
            fabricante: null,
            fechaCaducidad: null,
            loteMedicamento: null,
            formaFarmaceutica_id: null,
            condicionesEspTransp_id: null,
            registroSanitarioFolioAutorizacion: null,
            permisoImportacion: null,
            created_at: "2025-09-08T20:54:54.000Z",
            updated_at: "2025-09-08T20:54:54.000Z",
            deleted_at: null,
          },
          {
            id: 52064,
            fwb_id: 1035,
            mercanciasField_id: null,
            bienesTranspField: null,
            bienesTranspFieldSpecified: null,
            cantidadField: 1,
            cantidadFieldSpecified: null,
            cantidadTransportaField: null,
            claveSTCCField: null,
            claveSTCCFieldSpecified: null,
            claveUnidadField: 374,
            claveUnidadFieldSpecified: null,
            cveMaterialPeligrosoField: null,
            cveMaterialPeligrosoFieldSpecified: null,
            descripEmbalajeField: null,
            descripcionField: "Rueda de tren principal - Embraer 190",
            detalleMercanciaField: null,
            dimensionesField: null,
            embalajeField: null,
            embalajeFieldSpecified: null,
            fraccionArancelariaField: null,
            fraccionArancelariaFieldSpecified: null,
            materialPeligrosoField: null,
            materialPeligrosoFieldSpecified: null,
            monedaField: 149,
            monedaFieldSpecified: null,
            pesoEnKgField: 80,
            uUIDComercioExtField: null,
            unidadField: null,
            valorMercanciaField: 7000,
            valorMercanciaFieldSpecified: null,
            sectorCofepris_id: null,
            nombreIngredienteActivo: null,
            nomQuimico: null,
            denominacionGenericaProd: null,
            denominacionDistintivaProd: null,
            fabricante: null,
            fechaCaducidad: null,
            loteMedicamento: null,
            formaFarmaceutica_id: null,
            condicionesEspTransp_id: null,
            registroSanitarioFolioAutorizacion: null,
            permisoImportacion: null,
            created_at: "2025-09-08T20:54:54.000Z",
            updated_at: "2025-09-08T20:54:54.000Z",
            deleted_at: null,
          },
        ],
        c_claves_full_name: {
          4327: "23261507 - Maquina impresora tridimensional",
          5550: "25202203 - Ruedas de avion",
        },
        figura_transporte: [],
      },
    };
    // Función asíncrona para obtener catálogos de la API
    const fetchCatalogs = async () => {
      const baseURL = `${process.env.REACT_APP_URL_BACKEND}/api/v1/catalogs_cartaporte`;
      const urls = {
        unidad: `${baseURL}/getClaveUnidadPeso`,
        currency: `${baseURL}/getMonedas`,
        customs: `${baseURL}/getRegimenAduanero`,
        hazardous: `${baseURL}/getMaterialPeligroso`,
        pharmacist: `${baseURL}/getFormaFarmaceutica`,
        conditionsSpecial: `${baseURL}/getCondicionesEspecial`,
        packaging: `${baseURL}/getTipoEmalaje`,
        stations: `${baseURL}/getStation`,
        cofepris: `${baseURL}/getSectorCofepris`,
        pais: `${baseURL}/getPais`,
        figuraTransporte: `${baseURL}/getFiguraTransporte`,
        parteTransporte: `${baseURL}/getParteTransporte`,
      };

      const api = axios.create({
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      try {
        const results = {};
        let retryCount = 0;
        const maxRetries = 5;

        // Función para hacer una petición con reintentos
        const fetchWithRetry = async (key, url) => {
          let lastError;
          for (let i = 0; i < maxRetries; i++) {
            try {
              const response = await api.get(url);
              if (response.status === 200) {
                return response.data.data;
              }
            } catch (error) {
              lastError = error;
              console.error(`Intento ${i + 1} fallido para ${key}`);
              if (i < maxRetries - 1) {
                // Esperar un tiempo exponencial antes de reintentar
                await new Promise((resolve) =>
                  setTimeout(resolve, 1000 * Math.pow(2, i))
                );
              }
            }
          }
          throw (
            lastError ||
            new Error(
              `No se pudo obtener el catálogo ${key} después de ${maxRetries} intentos`
            )
          );
        };

        // Ejecutar las peticiones en serie
        for (const [key, url] of Object.entries(urls)) {
          try {
            results[key] = await fetchWithRetry(key, url);
            console.info(`Catálogo ${key} obtenido con éxito`);
          } catch (error) {
            console.error(`Error al obtener ${key}:`, error);
            results[key] = [];
          }
        }

        setCatalogs({
          unidad: results.unidad,
          currency: results.currency,
          customs: results.customs,
          hazardous: results.hazardous,
          pharmacist: results.pharmacist,
          conditionsSpecial: results.conditionsSpecial,
          packaging: results.packaging,
          stations: results.stations,
          cofepris: results.cofepris,
          pais: results.pais,
          figuraTransporte: results.figuraTransporte,
          parteTransporte: results.parteTransporte,
        });
      } catch (error) {
        console.error("Error general al obtener catálogos:", error);
      }
    };

    const getGuideData = async () => {
      try {
        let response;
        if (USE_FAKE_RESPONSE) {
          response = { data: fakeData };
        } else {
          response = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/v1/nationals/getMaster/${awbId}`,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            }
          );
        }

        const { status_sqs } = response.data.data.fwb;
        const mercancias = response.data.data.mercancias;

        setGuideData({
          guideInfo: response.data.data.fwb,
          goods: mercancias,
          merchandiseCode: response.data.data.c_claves_full_name,
          figura_transporte: response.data.data.figura_transporte[0],
          status_sqs: status_sqs,
        });

        setCurrentOptiond((prevOptions) => {
          const newOptions = { ...prevOptions };

          // Crear un mapeo de claves
          const merchandiseMap = {};
          const merchandiseData = formatSelet(
            response.data.data.c_claves_full_name
          );
          merchandiseData.forEach((item) => {
            merchandiseMap[item.value] = item;
          });

          if (mercancias.length > 0) {
            mercancias.forEach((mercancia, index) => {
              newOptions.amounts[index] = mercancia.cantidadField;
              newOptions.weights[index] = mercancia.pesoEnKgField;
              newOptions.worths[index] = mercancia.valorMercanciaField;
              newOptions.descriptions[index] = mercancia.descripcionField;
              newOptions.healthRegisters[index] =
                mercancia.registroSanitarioFolioAutorizacion;
              newOptions.importPermits[index] = mercancia.permisoImportacion;
              newOptions.cemicalNames[index] = mercancia.nomQuimico;
              newOptions.denominations[index] =
                mercancia.denominacionGenericaProd;
              newOptions.distinctiveDenominations[index] =
                mercancia.denominacionDistintivaProd;
              newOptions.dateExpiries[index] = mercancia.fechaCaducidad;
              newOptions.makers[index] = mercancia.fabricante;
              newOptions.medicationBatches[index] = mercancia.loteMedicamento;
              newOptions.activeIngredientName[index] =
                mercancia.nombreIngredienteActivo;

              // Asignar la clave de mercancía en la posición correcta
              const valueKey = mercancia.bienesTranspField;
              if (merchandiseMap[valueKey]) {
                newOptions.merchandiseKey[index] = merchandiseMap[valueKey];
              }
            });

            // Si hay mercancías, solo asignamos la clave
            if (newOptions.merchandiseKey.length === 0) {
              newOptions.merchandiseKey = [];
            }

            showDG(newOptions.merchandiseKey);
          } else {
            newOptions.merchandiseKey = [];
          }

          newOptions.rfcEmisor = response.data.data.fwb.Rfc_Emisor;
          newOptions.cfdi_type = response.data.data.fwb.type;

          // Nuevos campos👇
          const figuraTransporte = response.data.data.figura_transporte[0];
          if (figuraTransporte) {
            newOptions.has_transport = figuraTransporte.has_transport;
            setTransport(figuraTransporte.has_transport);
            newOptions.rfcFigura = figuraTransporte.rfcFigura;
            newOptions.numLicencia = figuraTransporte.numLicencia;
            newOptions.nombreFigura = figuraTransporte.nombreFigura;
            newOptions.numRegIdTribFigura = figuraTransporte.numRegIdTribFigura;
            newOptions.has_address = figuraTransporte.has_address;
            setAddress(figuraTransporte.has_address);
            newOptions.calle = figuraTransporte.calle;
            newOptions.numeroExterior = figuraTransporte.numeroExterior;
            newOptions.numeroInterior = figuraTransporte.numeroInterior;
            newOptions.colonia = figuraTransporte.colonia;
            newOptions.localidad = figuraTransporte.localidad;
            newOptions.referencia = figuraTransporte.referencia;
            newOptions.municipio = figuraTransporte.municipio;
            newOptions.estado = figuraTransporte.estado;
            newOptions.codigoPostal = figuraTransporte.codigoPostal;
          }
          // Fin de nuevos campos

          return newOptions;
        });

        setEmbarque(mercancias.length < 1 ? 0 : mercancias.length - 1);

        if (status_sqs === 1) {
          setShowModal({
            show: true,
            message: "Enviando petición de timbrado",
          });

          const checkStatus = async () => {
            try {
              const statusResponse = await axios.get(
                `${process.env.REACT_APP_URL_BACKEND}/api/v1/nationals/getMaster/${awbId}`,
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  },
                }
              );

              const { status_sqs, message } = statusResponse.data.data.fwb;

              setStatusSqs(status_sqs); // Usar el estado independiente

              setGuideData((prev) => ({
                ...prev,
                status_sqs: status_sqs,
              }));

              if (status_sqs === 2 || status_sqs === 3) {
                clearInterval(pollingInterval);
                setShowModal({
                  show: false,
                  message: message,
                });
              }
            } catch (error) {
              console.error("Error al verificar el estado:", error);
              clearInterval(pollingInterval);
              setShowModal({
                show: false,
                message: "",
              });
            }
          };

          const pollingInterval = setInterval(checkStatus, 5000);
          checkStatus();
          return () => clearInterval(pollingInterval);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const loadData = async () => {
      await getGuideData();
      await fetchCatalogs();
      setLoading(false); // Datos cargados, actualiza el estado de carga
    };

    loadData();
  }, []);

  useEffect(() => {
    const updateCurrentOptions = () => {
      if (!catalogs || !guideData.goods.length) return;

      const unidadOptions = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.unidad).filter(
            (unidad) => unidad.value == good.claveUnidadField
          )[0] || { value: "", label: "" }
        );
      });

      const currencyOptions = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.currency).filter(
            (currency) => currency.value == good.monedaField
          )[0] || { value: "", label: "" }
        );
      });

      const hazardousOptions = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.hazardous).filter(
            (hazardous) => hazardous.value == good.cveMaterialPeligrosoField
          )[0] || null
        );
      });

      const packagingOptions = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.packaging).filter(
            (packaging) => packaging.value == good.embalajeField
          )[0] || null
        );
      });

      const pharmacistOptions = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.pharmacist).filter(
            (pharmacist) => pharmacist.value == good.formaFarmaceutica_id
          )[0] || { value: "", label: "" }
        );
      });

      const customCurrent = formatSelet(catalogs.customs).filter(
        (custom) => custom.value == guideData.guideInfo.regimenAduanero_id
      );

      const cofepris = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.cofepris).filter(
            (cofepris) => cofepris.value == good.sectorCofepris_id
          )[0] || { value: "", label: "" }
        );
      });

      const conditionsSpecial = guideData.goods.map((good) => {
        return (
          formatSelet(catalogs.conditionsSpecial).filter(
            (cofepris) => cofepris.value == good.condicionesEspTransp_id
          )[0] || { value: "", label: "" }
        );
      });

      setCurrentOptiond((prevOptions) => ({
        ...prevOptions,
        unidad: unidadOptions,
        currency: currencyOptions,
        hazardous: hazardousOptions,
        packaging: packagingOptions,
        pharmacist: pharmacistOptions,
        customs: customCurrent,
        cofepris: cofepris,
        conditionsSpecial: conditionsSpecial,
      }));
    };

    updateCurrentOptions();
  }, [catalogs, guideData]);

  //Cargar datos de Nuevos campos👇
  useEffect(() => {
    const updateCurrentOptions = () => {
      if (!catalogs || !guideData.figura_transporte) return;

      const pais = formatSelet(catalogs.pais).filter(
        (a) => a.value == guideData.figura_transporte.pais_id
      )[0] || { value: "", label: "" };

      const parteTransporte = formatSelet(catalogs.parteTransporte).filter(
        (a) => a.value == guideData.figura_transporte.parteTransporte_id
      )[0] || { value: "", label: "" };

      const tipoFigura = formatSelet(catalogs.figuraTransporte).filter(
        (a) => a.value == guideData.figura_transporte.tipoFigura_id
      )[0] || { value: "", label: "" };

      const residenciaFiscalFigura = formatSelet(catalogs.pais).filter(
        (a) => a.value == guideData.figura_transporte.residenciaFiscalFigura_id
      )[0] || { value: "", label: "" };

      setCurrentOptiond((prevOptions) => ({
        ...prevOptions,
        pais: pais,
        parteTransporte: parteTransporte,
        tipoFigura: tipoFigura,
        residenciaFiscalFigura: residenciaFiscalFigura,
      }));
    };

    updateCurrentOptions();
  }, [catalogs, guideData]);

  // UseEffect para inicializar formData con currentOptios cuando currentOptios cambie
  useEffect(() => {
    // Función para extraer valores, maneja tanto objetos con propiedad 'value' como otros tipos
    const extractValues = (arr) =>
      Array.isArray(arr)
        ? arr.map((item) => {
            if (typeof item === "object" && item !== null && "value" in item) {
              return item.value ?? ""; // Si item.value es null o undefined, retorna ""
            } else {
              return item ?? ""; // Si item es null o undefined, retorna ""
            }
          })
        : "";

    setFormData((prevData) => ({
      ...prevData,
      cantidadField: extractValues(currentOptios.amounts),
      claveUnidadField: extractValues(currentOptios.unidad),
      monedaField: extractValues(currentOptios.currency),
      cveMaterialPeligrosoField: currentOptios.hazardous
        ? currentOptios.hazardous[0]?.value
        : null,
      embalajeField: currentOptios.packaging
        ? currentOptios.packaging[0]?.value
        : null,
      condicionesEspTransp: extractValues(currentOptios.conditionsSpecial),
      formaFarmaceutica: extractValues(currentOptios.pharmacist),
      sectorCOFEPRIS: extractValues(currentOptios.cofepris),
      nombreIngredienteActivo: extractValues(
        currentOptios.activeIngredientName
      ),
      nomQuimico: extractValues(currentOptios.cemicalNames),
      denominacionGenericaProd: extractValues(currentOptios.denominations),
      denominacionDistintivaProd: extractValues(
        currentOptios.distinctiveDenominations
      ),
      fabricante: extractValues(currentOptios.makers),
      fechaCaducidad: extractValues(currentOptios.dateExpiries),
      loteMedicamento: extractValues(currentOptios.medicationBatches),
      registroSanitarioFolioAutorizacion: extractValues(
        currentOptios.healthRegisters
      ),
      permisoImportacion: extractValues(currentOptios.importPermits),
      descripcionField: extractValues(currentOptios.descriptions),
      pesoEnKgField: extractValues(currentOptios.weights),
      bienesTranspField: extractValues(currentOptios.merchandiseKey),
      valorMercanciaField: extractValues(currentOptios.worths),
      rfcEmisor: currentOptios.rfcEmisor || null,
      cfdi_type: currentOptios.cfdi_type || null,
      regimenAduanero_id: currentOptios.customs.length
        ? currentOptios.customs[0].value
        : null,

      //nuevos Campos 👇
      has_transport: currentOptios.has_transport ? 1 : 0,
      parteTransporte: currentOptios.parteTransporte
        ? currentOptios.parteTransporte.value
        : null,
      tipoFigura: currentOptios.tipoFigura
        ? currentOptios.tipoFigura.value
        : null,
      rfcFigura: currentOptios.rfcFigura,
      numLicencia: currentOptios.numLicencia,
      nombreFigura: currentOptios.nombreFigura,
      numRegIdTribFigura: currentOptios.numRegIdTribFigura,
      residenciaFiscalFigura: currentOptios.residenciaFiscalFigura
        ? currentOptios.residenciaFiscalFigura.value
        : null,
      has_address: currentOptios.has_address ? 1 : 0,
      calle: currentOptios.calle,
      numeroExterior: currentOptios.numeroExterior,
      numeroInterior: currentOptios.numeroInterior,
      colonia: currentOptios.colonia,
      localidad: currentOptios.localidad,
      referencia: currentOptios.referencia,
      municipio: currentOptios.municipio,
      estado: currentOptios.estado,
      pais: currentOptios.pais ? currentOptios.pais.value : null,
      codigoPostal: currentOptios.codigoPostal,
      //nuevos Campos ☝
    }));
  }, [currentOptios]);

  useEffect(() => {
    if (
      guideData &&
      Array.isArray(guideData.goods) &&
      guideData.goods.length > 0
    ) {
      const mercancias = guideData.goods;
      const arrayFields = [
        "bienesTranspField",
        "claveUnidadField",
        "cantidadField",
        "pesoEnKgField",
        "valorMercanciaField",
        "monedaField",
        "descripcionField",
        "sectorCOFEPRIS",
        "nombreIngredienteActivo",
        "nomQuimico",
        "denominacionGenericaProd",
        "denominacionDistintivaProd",
        "fabricante",
        "fechaCaducidad",
        "loteMedicamento",
        "formaFarmaceutica",
        "condicionesEspTransp",
        "registroSanitarioFolioAutorizacion",
        "permisoImportacion",
      ];

      // Genera los arrays asegurando la misma longitud para todos
      const newFormData = { ...formData };
      arrayFields.forEach((field) => {
        newFormData[field] = mercancias.map((m) => m[field] ?? "");
      });

      setFormData((prev) => ({
        ...prev,
        ...newFormData,
      }));
    }
    // eslint-disable-next-line
  }, [guideData]);

  const handleCheckboxTransportChange = (e) => {
    const { checked } = e.target;
    setTransport(!transport);
    if (checked === true) {
      setFormData((prevState) => ({
        ...prevState,
        has_transport: 1,
      }));
      setCurrentOptiond((prevState) => ({
        ...prevState,
        has_transport: true,
      }));
    } else if (checked === false) {
      setFormData((prevState) => ({
        ...prevState,
        has_transport: 0,
        parteTransporte: null,
        tipoFigura: null,
        rfcFigura: null,
        numLicencia: null,
        nombreFigura: null,
        numRegIdTribFigura: null,
        residenciaFiscalFigura: null,
      }));
      setCurrentOptiond((prevState) => ({
        ...prevState,
        has_transport: false,
        parteTransporte: null,
        tipoFigura: null,
        rfcFigura: null,
        numLicencia: null,
        nombreFigura: null,
        numRegIdTribFigura: null,
        residenciaFiscalFigura: null,
      }));
    }
  };

  const handleCheckboxAddresstChange = (e) => {
    const { checked } = e.target;
    setAddress(!address);

    if (checked === true) {
      setFormData((prevState) => ({
        ...prevState,
        has_address: 1,
      }));
      setCurrentOptiond((prevState) => ({
        ...prevState,
        has_address: true,
      }));
    } else if (checked === false) {
      setFormData((prevState) => ({
        ...prevState,
        has_address: 0,
        calle: null,
        numeroExterior: null,
        numeroInterior: null,
        colonia: null,
        localidad: null,
        referencia: null,
        municipio: null,
        estado: null,
        pais: null,
        codigoPostal: null,
      }));
      setCurrentOptiond((prevState) => ({
        ...prevState,
        has_address: false,
        calle: null,
        numeroExterior: null,
        numeroInterior: null,
        colonia: null,
        localidad: null,
        referencia: null,
        municipio: null,
        estado: null,
        codigoPostal: null,
        pais: { value: "", label: "" },
      }));
    }
  };

  const statusCollapseCofepris = () => setStatusCof((prev) => !prev);

  const addMed = () => {
    const newIndex = formData.bienesTranspField.length; // Obtener el nuevo índice

    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };

      // Para cada campo de array, agregar un elemento vacío si no existe o usar el valor actual
      const fields = [
        "bienesTranspField",
        "claveUnidadField",
        "cantidadField",
        "pesoEnKgField",
        "valorMercanciaField",
        "monedaField",
        "descripcionField",
        "sectorCOFEPRIS",
        "nombreIngredienteActivo",
        "nomQuimico",
        "denominacionGenericaProd",
        "denominacionDistintivaProd",
        "fabricante",
        "fechaCaducidad",
        "loteMedicamento",
        "formaFarmaceutica",
        "condicionesEspTransp",
        "registroSanitarioFolioAutorizacion",
        "permisoImportacion",
      ];

      fields.forEach((field) => {
        if (!Array.isArray(newFormData[field])) {
          newFormData[field] = [];
        }
        // Agregar un elemento vacío o el valor por defecto
        newFormData[field] = [...newFormData[field], ""];
      });

      return newFormData;
    });

    setEmbarque((prev) => prev + 1);
  };

  const removeMed = (index) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };

      const keys = [
        "bienesTranspField",
        "claveUnidadField",
        "cantidadField",
        "pesoEnKgField",
        "valorMercanciaField",
        "monedaField",
        "descripcionField",
        "sectorCOFEPRIS",
        "nombreIngredienteActivo",
        "nomQuimico",
        "denominacionGenericaProd",
        "denominacionDistintivaProd",
        "fabricante",
        "fechaCaducidad",
        "loteMedicamento",
        "formaFarmaceutica",
        "condicionesEspTransp",
        "registroSanitarioFolioAutorizacion",
        "permisoImportacion",
      ];

      keys.forEach((key) => {
        if (Array.isArray(newFormData[key])) {
          newFormData[key] = newFormData[key].filter((_, i) => i !== index);
        }
      });

      return newFormData;
    });

    setEmbarque((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const handleDeleteCustoms = () => {
    setCurrentOptiond((prevOptions) => ({
      ...prevOptions,
      customs: [{ value: "", label: "" }],
    }));
  };

  const handleDeleteParteTrans = () => {
    setCurrentOptiond((prevOptions) => ({
      ...prevOptions,
      parteTransporte: {},
    }));
  };

  const handleDeleteResFiscal = () => {
    setCurrentOptiond((prevOptions) => ({
      ...prevOptions,
      residenciaFiscalFigura: {},
    }));
  };

  const validateRequiredFields = () => {
    const errors = [];

    // Mapeo de nombres de campo a labels descriptivos
    const fieldLabels = {
      // EMBARQUE Y MERCANCIAS
      bienesTranspField: "Clave de mercancía",
      claveUnidadField: "Clave Unidad",
      cantidadField: "Cantidad",
      pesoEnKgField: "Peso",
      descripcionField: "Descripción de la mercancía",
      valorMercanciaField: "Valor",
      monedaField: "Moneda",

      // TRANSPORTE
      parteTransporte: "Parte Transporte",
      tipoFigura: "Tipo de Figura",
      rfcFigura: "RFC de la figura",
      numLicencia: "Número de Licencia",
      nombreFigura: "Nombre de la figura",
      numRegIdTribFigura: "Número de registro id Tributario",
      residenciaFiscalFigura: "Residencia Fiscal de la Figura",

      // DOMICILIO
      calle: "Calle",
      numeroExterior: "Número Exterior",
      numeroInterior: "Número Interior",
      colonia: "Colonia",
      localidad: "Localidad",
      referencia: "Referencia",
      municipio: "Municipio",
      estado: "Estado",
      pais: "País",
      codigoPostal: "Código Postal",
    };

    // Validar campos de EMBARQUE Y MERCANCIAS
    const mercanciaFields = [
      "bienesTranspField",
      "claveUnidadField",
      "cantidadField",
      "pesoEnKgField",
      "descripcionField",
    ];

    mercanciaFields.forEach((field) => {
      if (Array.isArray(formData[field])) {
        formData[field].forEach((value, index) => {
          if (!value || value === "" || value === null) {
            const fieldLabel = fieldLabels[field] || field;
            errors.push(
              `<b>${fieldLabel}</b> en el embarque ${index + 1} es requerido`
            );
          }
        });
      }
    });

    // Validar que valorMercanciaField y monedaField coincidan
    if (
      formData.valorMercanciaField &&
      formData.valorMercanciaField.length > 0
    ) {
      formData.valorMercanciaField.forEach((valor, index) => {
        const moneda = formData.monedaField && formData.monedaField[index];

        if (
          valor &&
          valor !== "" &&
          valor !== "0" &&
          (!moneda || moneda === "")
        ) {
          errors.push(
            `Cuando hay <b>valor</b> en el embarque ${
              index + 1
            }, debe especificar la <b>moneda</b>`
          );
        }

        if (
          moneda &&
          moneda !== "" &&
          (!valor || valor === "" || valor === "0")
        ) {
          errors.push(
            `Cuando hay <b>moneda</b> en el embarque ${
              index + 1
            }, debe especificar el <b>valor</b>`
          );
        }
      });
    }

    // Validación condicional para transporte
    if (transport) {
      const transportRequiredFields = [
        "parteTransporte",
        "tipoFigura",
        "rfcFigura",
      ];
      const transportOptionalFields = [
        "numLicencia",
        "nombreFigura",
        "numRegIdTribFigura",
        "residenciaFiscalFigura",
      ];

      transportRequiredFields.forEach((field) => {
        if (
          !formData[field] ||
          formData[field] === "" ||
          formData[field] === null
        ) {
          const fieldLabel = fieldLabels[field] || field;
          errors.push(
            `<b>${fieldLabel}</b> es requerido cuando transporte está activado`
          );
        }
      });
    }

    // Validación condicional para domicilio
    if (address) {
      const addressRequiredFields = [
        "calle",
        "numeroExterior",
        "colonia",
        "municipio",
        "estado",
        "pais",
        "codigoPostal",
      ];
      const addressOptionalFields = [
        "numeroInterior",
        "localidad",
        "referencia",
      ];

      addressRequiredFields.forEach((field) => {
        if (
          !formData[field] ||
          formData[field] === "" ||
          formData[field] === null
        ) {
          const fieldLabel = fieldLabels[field] || field;
          errors.push(
            `<b>${fieldLabel}</b> es requerido cuando domicilio está activado`
          );
        }
      });
    }

    return errors;
  };

  const validateQuantitiesAndWeights = () => {
    const errors = [];

    const totalPieces = guideData.guideInfo.pieces;
    const totalWeight = guideData.guideInfo.weight;

    const sumQuantities = formData.cantidadField.reduce((sum, cantidad) => {
      const numCantidad = parseFloat(cantidad) || 0;
      return sum + numCantidad;
    }, 0);

    const sumWeights = formData.pesoEnKgField.reduce((sum, peso) => {
      const numPeso = parseFloat(peso) || 0;
      return sum + numPeso;
    }, 0);

    // Validar cantidades
    if (sumQuantities !== totalPieces) {
      errors.push(
        `<b>La suma de las cantidades de las mercancías (${sumQuantities}) no coincide con el total de piezas de la guía (${totalPieces})</b>`
      );
    }

    // Validar pesos (usando toFixed para evitar problemas de precisión decimal)
    if (Math.abs(sumWeights - totalWeight) > 0.01) {
      // Margen de error pequeño para decimales
      errors.push(
        `<b>La suma de los pesos de las mercancías (${sumWeights.toFixed(
          2
        )}) no coincide con el peso total de la guía (${totalWeight})</b>`
      );
    }

    return errors;
  };

  const handleFormSubmit = async (data) => {
    const validationErrors = validateRequiredFields();
    const quantityErrors = validateQuantitiesAndWeights();

    const allErrors = [...validationErrors, ...quantityErrors];

    if (allErrors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Error de validación",
        html: allErrors.join("<br>"),
        confirmButtonText: "Entendido",
      });
      return;
    }
    // Create the formattedData object with the correct structure
    const formattedData = {
      fwb_id: formData.fwb_id,
      cfdi_type: formData.cfdi_type,
      sucursal: formData.sucursal,
      bienesTranspField: formData.bienesTranspField,
      claveUnidadField: formData.claveUnidadField,
      cantidadField: formData.cantidadField,
      pesoEnKgField: formData.pesoEnKgField,
      valorMercanciaField: formData.valorMercanciaField,
      monedaField: formData.monedaField,
      descripcionField: formData.descripcionField,
      sectorCOFEPRIS: formData.sectorCOFEPRIS,
      nombreIngredienteActivo: formData.nombreIngredienteActivo,
      nomQuimico: formData.nomQuimico,
      denominacionGenericaProd: formData.denominacionGenericaProd,
      denominacionDistintivaProd: formData.denominacionDistintivaProd,
      fabricante: formData.fabricante,
      fechaCaducidad: formData.fechaCaducidad,
      loteMedicamento: formData.loteMedicamento,
      formaFarmaceutica: formData.formaFarmaceutica,
      condicionesEspTransp: formData.condicionesEspTransp,
      registroSanitarioFolioAutorizacion:
        formData.registroSanitarioFolioAutorizacion,
      permisoImportacion: formData.permisoImportacion,
      rfcEmisor: formData.rfcEmisor,
      cveMaterialPeligrosoField: formData.cveMaterialPeligrosoField,
      embalajeField: formData.embalajeField,
      //nuevos campos 👇
      has_transport: formData.has_transport,
      parteTransporte: formData.parteTransporte,
      tipoFigura: formData.tipoFigura,
      rfcFigura: formData.rfcFigura,
      numLicencia: formData.numLicencia,
      nombreFigura: formData.nombreFigura,
      numRegIdTribFigura: formData.numRegIdTribFigura,
      residenciaFiscalFigura: formData.residenciaFiscalFigura,
      has_address: formData.has_address,
      calle: formData.calle,
      numeroExterior: formData.numeroExterior,
      numeroInterior: formData.numeroInterior,
      colonia: formData.colonia,
      localidad: formData.localidad,
      referencia: formData.referencia,
      municipio: formData.municipio,
      estado: formData.estado,
      pais: formData.pais,
      codigoPostal: formData.codigoPostal,
    };

    const body = {
      taskType: "processNational",
      payload: formattedData,
    };

    console.log("====================================");
    console.log(body);
    console.log("====================================");

    try {
      const resSqs = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/nationals/updateStatusSqs`,
        {
          fwb_id: awbId,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (resSqs.data.code === 1) {
        setShowModal({
          show: true,
          message: "Generando Carta Porte",
        });

        const res = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/cronjob/testSqs`,
          body,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        const checkStatus = async () => {
          try {
            const statusResponse = await axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/nationals/getMaster/${awbId}`,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
              }
            );

            const { status_sqs, message } = statusResponse.data.data.fwb;

            setStatusSqs(status_sqs); // Usar el estado independiente

            setGuideData((prev) => ({
              ...prev,
              status_sqs: status_sqs,
            }));

            if (status_sqs === 2 || status_sqs === 3) {
              clearInterval(pollingInterval);
              setShowModal({
                show: false,
                message: message,
              });
            }
          } catch (error) {
            console.error("Error al verificar el estado:", error);
            clearInterval(pollingInterval);
            setShowModal({
              show: false,
              message: "",
            });
          }
        };

        const pollingInterval = setInterval(checkStatus, 5000);
        checkStatus();
        return () => clearInterval(pollingInterval);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormData = (e, index) => {
    const { name, value } = e.target;

    setFormData((prevState) => {
      // Caso especial para campos que no son arrays
      if (name === "cveMaterialPeligrosoField" || name === "embalajeField") {
        return {
          ...prevState,
          [name]: value,
        };
      }

      // Para campos que son arrays
      const currentArray = Array.isArray(prevState[name])
        ? [...prevState[name]]
        : [];

      // Asegurarse que el índice existe
      if (index >= 0 && index < currentArray.length) {
        currentArray[index] = value;
      } else {
        currentArray.push(value);
      }

      return {
        ...prevState,
        [name]: currentArray,
      };
    });
  };

  useEffect(() => {
    // Verificar consistencia de arrays
    const arrayFields = [
      "bienesTranspField",
      "claveUnidadField",
      "cantidadField",
      "pesoEnKgField",
      "valorMercanciaField",
      "monedaField",
      "descripcionField",
      "sectorCOFEPRIS",
      "nombreIngredienteActivo",
      "nomQuimico",
      "denominacionGenericaProd",
      "denominacionDistintivaProd",
      "fabricante",
      "fechaCaducidad",
      "loteMedicamento",
      "formaFarmaceutica",
      "condicionesEspTransp",
      "registroSanitarioFolioAutorizacion",
      "permisoImportacion",
    ];

    // Obtener longitudes de todos los arrays
    const lengths = arrayFields.map((field) =>
      Array.isArray(formData[field]) ? formData[field].length : 0
    );

    // Verificar si hay inconsistencias
    const uniqueLengths = new Set(lengths);
    if (uniqueLengths.size > 1) {
      console.info(
        "Inconsistencia en longitudes de arrays:",
        Object.fromEntries(arrayFields.map((field, i) => [field, lengths[i]]))
      );

      // Corregir inconsistencias (opcional)
      const maxLength = Math.max(...lengths);
      const correctedData = { ...formData };
      let needsCorrection = false;

      arrayFields.forEach((field) => {
        if (!Array.isArray(correctedData[field])) {
          correctedData[field] = Array(maxLength).fill("");
          needsCorrection = true;
        } else if (correctedData[field].length < maxLength) {
          correctedData[field] = [
            ...correctedData[field],
            ...Array(maxLength - correctedData[field].length).fill(""),
          ];
          needsCorrection = true;
        } else if (correctedData[field].length > maxLength) {
          correctedData[field] = correctedData[field].slice(0, maxLength);
          needsCorrection = true;
        }
      });

      if (needsCorrection) {
        console.info("Corrigiendo inconsistencias en arrays...");
        setFormData(correctedData);
      }
    }
  }, [formData]);

  useEffect(() => {
    // Función para verificar si hay mercancías peligrosas
    const checkDangerousGoods = async () => {
      if (formData.bienesTranspField && formData.bienesTranspField.length > 0) {
        let hasDangerousGoods = 0;
        for (const item of formData.bienesTranspField) {
          if (item) {
            try {
              const response = await axios.get(
                `${process.env.REACT_APP_URL_BACKEND}/api/v1/catalogs_cartaporte/getIsDG/${item}`,
                {
                  headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  },
                }
              );
              if (response.data.code === 1 && response.data.is_dg === 1) {
                hasDangerousGoods = 1;
                break;
              }
            } catch (error) {
              console.error(error);
            }
          }
        }
        setIsDg(hasDangerousGoods);
      }
    };

    checkDangerousGoods();
  }, [formData.bienesTranspField]);

  // console.log("================catalogos====================");
  // console.log(catalogs);
  // console.log("=======datos de la guia===========");
  // console.log(guideData);
  // console.log("=======Opciones seleccionadas===========");
  // console.log(currentOptios);
  // console.log("=======numero embarques===========");
  // console.log(embarque);
  // console.log("=======peligroso===========");
  // console.log(isDg);
  // console.log("=======formData===========");
  // console.log(formData);

  if (loading) {
    return <div>Cargando datos...</div>; // Muestra un indicador de carga mientras se obtienen los datos
  }

  //vista final
  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="card mb-4">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <form
                    onSubmit={handleSubmit(handleFormSubmit)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  >
                    <div className="row">
                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Guía:</small>
                          </b>
                        </p>
                        <p className="amc-text">{guideData.guideInfo.awb}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Origen:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.origin}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Destino:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.destinaiton}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Piezas:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.pieces}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Peso:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.weight}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>DEP:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.date}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>DDX:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.its_ddx === 1 ? "Si" : "No"}</p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Guía de crédito:</small>
                          </b>
                        </p>
                        <p>
                          {guideData.guideInfo.EsGuiaDeCredito === 1
                            ? "Si"
                            : "No"}
                        </p>
                      </div>

                      <div className="col-6 col-sm-6 col-md-3 mb-2">
                        <p
                          className="font-semibold"
                          style={{ marginBottom: "0px" }}
                        >
                          <b>
                            <small>Descripción:</small>
                          </b>
                        </p>
                        <p>{guideData.guideInfo.description}</p>
                      </div>
                    </div>

                    <hr></hr>

                    <div className="row mt-3">
                      <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                        <label>Regimen Aduanero</label>
                        <div className="input-group mt-2">
                          <SelectWithFilter
                            options={formatSelet(catalogs.customs)}
                            current={currentOptios.customs[0]}
                            id="regimenAduanero_id"
                            name={"regimenAduanero_id"}
                            handleFormData={handleFormData}
                            index={0}
                            isDisabled={true}
                          />
                          <button
                            type="button"
                            className="btn btn-danger boton-trash"
                            onClick={handleDeleteCustoms}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </div>
                    </div>

                    <hr></hr>

                    <div className="row mt-3">
                      <div className="form-group col-3 col-sm-3 col-md-3 mb-2">
                        <p className="mb-1 font-semibold">Que Tipo de CFDI</p>
                      </div>

                      <div className="form-group col-3 col-sm-3 col-md-3 mb-2">
                        <label>
                          <input
                            type="radio"
                            id="cfdi_type_Ingreso"
                            name="cfdi_type"
                            value="I"
                            defaultChecked={currentOptios.cfdi_type === "I"}
                            style={{ marginRight: "10px" }}
                            onChange={(e) => {
                              handleFormData(e, 0);
                            }}
                          />
                          <span>INGRESO</span>
                        </label>
                      </div>

                      <div className="form-group col-3 col-sm-3 col-md-3 mb-2">
                        <label>
                          <input
                            type="radio"
                            name="cfdi_type"
                            id="cfdi_type_Comat"
                            value="T"
                            defaultChecked={currentOptios.cfdi_type !== "I"}
                            style={{ marginRight: "10px" }}
                            onChange={(e) => {
                              handleFormData(e, 0);
                            }}
                          />
                          <span>COMAT AM/5D</span>
                        </label>
                      </div>
                    </div>

                    <hr></hr>

                    <div className="row mt-3">
                      <p className="font-semibold">EMBARQUE Y MERCANCIAS</p>

                      <div className="clons-container">
                        <div className="clonable row">
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Clave de mercancia</label>

                            <SelectWithFilter
                              options={formatSelet(catalogs.merchandiseKey)}
                              current={currentOptios.merchandiseKey[0]}
                              onInputChange={handleInputChange}
                              id="bienesTranspField"
                              name={"bienesTranspField"}
                              handleFormData={handleFormData}
                              index={0}
                              showDG={showDG}
                            />
                          </div>

                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Clave Unidad</label>
                            <SelectWithFilter
                              options={formatSelet(catalogs.unidad)}
                              current={currentOptios.unidad[0]}
                              id={"claveUnidadField"}
                              name={"claveUnidadField"}
                              handleFormData={handleFormData}
                              index={0}
                            />
                          </div>

                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Cantidad</label>
                            <input
                              type="text"
                              className="form-control"
                              id="cantidadField"
                              min="1"
                              defaultValue={currentOptios.amounts[0] || ""}
                              name="cantidadField"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                            />
                          </div>

                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Peso</label>
                            <input
                              type="text"
                              className="form-control"
                              id="pesoEnKgField"
                              min="1"
                              defaultValue={currentOptios.weights[0] || ""}
                              name="pesoEnKgField"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                            />
                          </div>

                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Valor</label>
                            <input
                              type="text"
                              className="form-control"
                              id="valorMercanciaField"
                              min="1"
                              defaultValue={currentOptios.worths[0] || ""}
                              name="valorMercanciaField"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                            />
                          </div>

                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Moneda</label>

                            <SelectWithFilter
                              options={formatSelet(catalogs.currency)}
                              current={currentOptios.currency[0]}
                              id={"monedaField"}
                              name={"monedaField"}
                              handleFormData={handleFormData}
                              index={0}
                            />
                          </div>

                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">
                              Descripción de la mercancia
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="descripcionField"
                              placeholder=""
                              defaultValue={currentOptios.descriptions[0] || ""}
                              name="descripcionField"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                            />
                          </div>

                          <div className="container my-2">
                            <button
                              type="button"
                              className="btn btn-primary custom-background collapsed"
                              onClick={statusCollapseCofepris}
                            >
                              COFEPRIS
                              <svg
                                className={
                                  "bi bi-chevron-down " +
                                  (statusCof ? "icon-down" : "icon-up")
                                }
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ marginLeft: "5px" }}
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.793l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                            </button>

                            <div
                              className={
                                "row mt-4 " +
                                (statusCof
                                  ? "active-collapse"
                                  : "collapse-cofepris")
                              }
                            >
                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">Sector COFEPRIS</label>
                                <SelectWithFilter
                                  options={formatSelet(catalogs.cofepris)}
                                  current={currentOptios.cofepris[0]}
                                  id={"sectorCOFEPRIS"}
                                  name={"sectorCOFEPRIS"}
                                  handleFormData={handleFormData}
                                  index={0}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Nombre Ingrediente Activo
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="nombreIngredienteActivo"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.activeIngredientName[0] || ""
                                  }
                                  name="nombreIngredienteActivo"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">Nombre Químico</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="nomQuimico"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.cemicalNames[0] || ""
                                  }
                                  name="nomQuimico"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Denominación Genérica del Producto
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="denominacionGenericaProd"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.denominations[0] || ""
                                  }
                                  name="denominacionGenericaProd"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Denominación Distintiva del Producto
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="denominacionDistintivaProd"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.distinctiveDenominations[0] ||
                                    ""
                                  }
                                  name="denominacionDistintivaProd"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">Fabricante</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="fabricante"
                                  placeholder=""
                                  defaultValue={currentOptios.makers[0] || ""}
                                  name="fabricante"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Fecha de Caducidad
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="fechaCaducidad"
                                  placeholder="dd/mm/aaaa"
                                  defaultValue={
                                    currentOptios.dateExpiries[0] || ""
                                  }
                                  name="fechaCaducidad"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Lote del Medicamento
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="loteMedicamento"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.medicationBatches[0] || ""
                                  }
                                  name="loteMedicamento"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Forma Farmacéutica
                                </label>

                                <SelectWithFilter
                                  options={formatSelet(catalogs.pharmacist)}
                                  current={currentOptios.pharmacist[0]}
                                  name={"formaFarmaceutica"}
                                  id={"formaFarmaceutica"}
                                  handleFormData={handleFormData}
                                  index={0}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Condiciones Especiales de Transporte
                                </label>
                                <SelectWithFilter
                                  options={formatSelet(
                                    catalogs.conditionsSpecial
                                  )}
                                  current={currentOptios.conditionsSpecial[0]}
                                  id={"condicionesEspTransp"}
                                  name={"condicionesEspTransp"}
                                  handleFormData={handleFormData}
                                  index={0}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Registro Sanitario Folio de Autorización
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="registroSanitarioFolioAutorizacion"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.healthRegisters[0] || ""
                                  }
                                  name="registroSanitarioFolioAutorizacion"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>

                              <div className="col-6 col-sm-6 col-md-3 mb-2">
                                <label className="mb-2">
                                  Permiso de Importación
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="permisoImportacion"
                                  placeholder=""
                                  defaultValue={
                                    currentOptios.importPermits[0] || ""
                                  }
                                  name="permisoImportacion"
                                  onChange={(e) => {
                                    handleFormData(e, 0);
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <hr className="mt-2"></hr>
                        </div>
                      </div>

                      {/* //se agrega la secciòn con los campos de embarque y mercancia */}
                      {Array.from({ length: embarque }).map((_, index) => (
                        <>
                          <Embarques
                            index={index}
                            setCatalogs={setCatalogs}
                            catalogs={catalogs}
                            currentOptios={currentOptios}
                            remover={removeMed}
                            handleFormData={handleFormData}
                            showDG={showDG}
                          />
                        </>
                      ))}
                      {/* //fin de la secciòn con los campos de embarque y mercancia */}

                      {/* //boton verde agregar + */}
                      <div className="col-12 text-center mt-1">
                        <div className="d-flex justify-content-center">
                          <button
                            type="button"
                            className="btn btn-success d-flex align-items-center justify-content-center"
                            style={{
                              padding: "6px 12px",
                              minWidth: "35px",
                              minHeight: "40px",
                            }}
                            onClick={() => {
                              addMed();
                            }}
                          >
                            <svg
                              className="svg-inline--fa fa-plus fa-w-14"
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="fas"
                              data-icon="plus"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                              data-fa-i2svg=""
                              style={{
                                color: "white",
                                width: "20px",
                                height: "20px",
                              }}
                            >
                              <path
                                fill="currentColor"
                                d="M436 236H276V76c0-13.3-10.7-24-24-24h-40c-13.3 0-24 10.7-24 24v160H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h176v160c0 13.3 10.7 24 24 24h40c13.3 0 24-10.7 24-24V300h160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12z"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* //fin del boton verde agregar + */}

                    <hr></hr>

                    <div className="row mt-3">
                      <p className="font-semibold">EMISOR</p>
                      <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                        <label>RFC del Emisor</label>
                        <select
                          id="rfcEmisor"
                          name="rfcEmisor"
                          className="form-select mt-2"
                          onChange={(e) => {
                            handleFormData(e, 0);
                          }}
                        >
                          <option>Selecciona ...</option>
                          <option
                            defaultValue="AEC1102161K3"
                            selected={currentOptios.rfcEmisor == "AEC1102161K3"}
                          >
                            AEC1102161K3
                          </option>
                          <option
                            defaultValue="AME880912I89"
                            selected={currentOptios.rfcEmisor == "AME880912I89"}
                          >
                            AME880912I89
                          </option>
                          <option
                            defaultValue="AER970617UH7"
                            selected={currentOptios.rfcEmisor == "AER970617UH7"}
                          >
                            AER970617UH7
                          </option>
                        </select>
                      </div>
                    </div>

                    <hr></hr>

                    {/* Nueva seccion👇👇 */}

                    <div className="row mt-3">
                      <p className="font-semibold">
                        Transporte{" "}
                        <input
                          type="checkbox"
                          name="has_transport"
                          id="has_transport"
                          style={{ marginLeft: "10px" }}
                          checked={transport ? true : false}
                          onChange={(e) => {
                            handleCheckboxTransportChange(e);
                          }}
                        />{" "}
                      </p>
                      <div className="clons-container">
                        <div className="clonable row">
                          {/* Parte Transporte */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label>Parte Transporte</label>
                            <div className="input-group mt-2">
                              <SelectWithFilter
                                options={formatSelet(catalogs.parteTransporte)}
                                current={currentOptios.parteTransporte}
                                id="parteTransporte"
                                name="parteTransporte"
                                handleFormData={handleFormData}
                                index={0}
                                isDisabled={transport ? false : true}
                              />
                              <button
                                type="button"
                                className="btn btn-danger boton-trash"
                                onClick={handleDeleteParteTrans}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </div>

                          {/* Tipo de Figura */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Tipo de Figura</label>

                            <SelectWithFilter
                              options={formatSelet(catalogs.figuraTransporte)}
                              current={currentOptios.tipoFigura}
                              id="tipoFigura"
                              name={"tipoFigura"}
                              handleFormData={handleFormData}
                              index={0}
                              isDisabled={transport ? false : true}
                            />
                          </div>

                          {/* Rfc de la figura */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Rfc de la figura</label>
                            <input
                              type="text"
                              className="form-control"
                              id="rfcFigura"
                              min="1"
                              value={formData.rfcFigura || ""}
                              name="rfcFigura"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={transport ? false : true}
                            />
                          </div>

                          {/* Numero de Licencia */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Numero de Licencia</label>
                            <input
                              type="text"
                              className="form-control"
                              id="numLicencia"
                              min="1"
                              value={formData.numLicencia || ""}
                              name="numLicencia"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={transport ? false : true}
                            />
                          </div>

                          {/* Nombre de la figura */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Nombre de la figura</label>
                            <input
                              type="text"
                              className="form-control"
                              id="nombreFigura"
                              min="1"
                              value={formData.nombreFigura || ""}
                              name="nombreFigura"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={transport ? false : true}
                            />
                          </div>

                          {/* Numero de registro id Tributario */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">
                              Numero de registro id Tributario
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="numRegIdTribFigura"
                              min="1"
                              value={formData.numRegIdTribFigura || ""}
                              name="numRegIdTribFigura"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={transport ? false : true}
                            />
                          </div>

                          {/* Residencia Fiscal de la Figura */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label>Residencia Fiscal de la Figura</label>
                            <div className="input-group mt-2">
                              <SelectWithFilter
                                options={formatSelet(catalogs.pais)}
                                current={currentOptios.residenciaFiscalFigura}
                                id="residenciaFiscalFigura"
                                name="residenciaFiscalFigura"
                                handleFormData={handleFormData}
                                index={0}
                                isDisabled={transport ? false : true}
                              />
                              <button
                                type="button"
                                className="btn btn-danger boton-trash"
                                onClick={handleDeleteResFiscal}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <p className="font-semibold deliveri">
                        Domicilio{" "}
                        <input
                          type="checkbox"
                          name="has_address"
                          id="has_address"
                          checked={address ? true : false}
                          style={{ marginLeft: "10px" }}
                          onChange={(e) => {
                            handleCheckboxAddresstChange(e);
                          }}
                        />{" "}
                      </p>
                      <div className="clons-container">
                        <div className="clonable row">
                          {/* Calle */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Calle</label>
                            <input
                              type="text"
                              className="form-control"
                              id="calle"
                              min="1"
                              value={formData.calle || ""}
                              name="calle"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Número Exterior */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Número Exterior</label>
                            <input
                              type="text"
                              className="form-control"
                              id="numeroExterior"
                              min="1"
                              value={formData.numeroExterior || ""}
                              name="numeroExterior"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Número Interior */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Número Interior</label>
                            <input
                              type="text"
                              className="form-control"
                              id="numeroInterior"
                              min="1"
                              value={formData.numeroInterior || ""}
                              name="numeroInterior"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Colonia */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Colonia</label>
                            <input
                              type="text"
                              className="form-control"
                              id="colonia"
                              min="1"
                              value={formData.colonia || ""}
                              name="colonia"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Localidad */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Localidad</label>
                            <input
                              type="text"
                              className="form-control"
                              id="localidad"
                              min="1"
                              value={formData.localidad || ""}
                              name="localidad"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Referencia */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Referencia</label>
                            <input
                              type="text"
                              className="form-control"
                              id="referencia"
                              min="1"
                              value={formData.referencia || ""}
                              name="referencia"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Municipio */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Municipio</label>
                            <input
                              type="text"
                              className="form-control"
                              id="municipio"
                              placeholder=""
                              value={formData.municipio || ""}
                              name="municipio"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Estado */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Estado</label>
                            <input
                              type="text"
                              className="form-control"
                              id="estado"
                              placeholder=""
                              value={formData.estado || ""}
                              name="estado"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          {/* Pais */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Pais</label>
                            <SelectWithFilter
                              options={formatSelet(catalogs.pais)}
                              current={currentOptios.pais}
                              id="pais"
                              name={"pais"}
                              handleFormData={handleFormData}
                              index={0}
                              isDisabled={address ? false : true}
                            />
                          </div>

                          {/* Código Postal */}
                          <div className="form-group col-6 col-sm-6 col-md-3 mb-2">
                            <label className="mb-2">Código Postal</label>
                            <input
                              type="text"
                              className="form-control"
                              id="codigoPostal"
                              placeholder=""
                              value={formData.codigoPostal || ""}
                              name="codigoPostal"
                              onChange={(e) => {
                                handleFormData(e, 0);
                              }}
                              disabled={address ? false : true}
                            />
                          </div>

                          <hr className="mt-2"></hr>
                        </div>
                      </div>
                    </div>

                    {/* 👆👆Nueva seccion */}

                    <div style={isDg === 0 ? { display: "none" } : {}}>
                      {/* {isVisible && ( */}
                      <div className="row mt-3">
                        <p className="font-semibold">
                          MATERIAL PELIGROSO (
                          <span className="small text-danger">
                            La clave de mercancía seleccionada corresponde a un
                            material peligroso
                          </span>
                          )
                        </p>
                        <div className="form-group col-6 col-sm-6 col-md-6">
                          <label className="mb-2">
                            Clave Material Peligroso
                          </label>
                          <SelectWithFilter
                            options={formatSelet(catalogs.hazardous)}
                            current={currentOptios.hazardous[0]}
                            id={"cveMaterialPeligrosoField"}
                            name={"cveMaterialPeligrosoField"}
                            menuPlacement="top"
                            className="w-100"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: "100%",
                              }),
                            }}
                            handleFormData={handleFormData}
                            index={0}
                          />
                        </div>

                        <div className="form-group col-6 col-sm-6 col-md-6">
                          <label className="mb-2">Tipo de Embalaje</label>
                          <SelectWithFilter
                            options={formatSelet(catalogs.packaging)}
                            current={currentOptios.packaging[0]}
                            id="tipoEmbalaje"
                            name="embalajeField"
                            menuPlacement="top"
                            className="w-100"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: "100%",
                              }),
                            }}
                            handleFormData={handleFormData}
                            index={0}
                          />
                        </div>
                      </div>
                      {/* )} */}
                    </div>

                    <hr></hr>

                    <div className="row mt-3">
                      <div className="col-md-12 mb-4">
                        {/* Mensaje arriba */}
                        {(guideData?.status_sqs === 2 ||
                          guideData?.status_sqs === 3) &&
                          guideData?.guideInfo?.message?.trim() && (
                            <div
                              className={`alert ${
                                guideData?.status_sqs === 2
                                  ? "alert-success"
                                  : "alert-danger"
                              } mb-2`}
                              role="alert"
                            >
                              {guideData?.guideInfo?.message}
                            </div>
                          )}

                        {/* Botón abajo (derecha) */}
                        <div className="d-flex justify-content-end">
                          {(guideData?.status_sqs === 1 ||
                            guideData?.status_sqs === null ||
                            guideData?.status_sqs === 3) && (
                            <button
                              type="submit"
                              className="btn btn-primary custom-background"
                              style={{ width: "180px", whiteSpace: "nowrap" }}
                            >
                              Guardar y Timbrar
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal.show}
        onHide={() => {
          setShowModal((prevOptions) => ({
            ...prevOptions,
            show: false,
          }));
        }}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
          <span className="fw-bold">{showModal.message}</span>
        </div>
      </Modal>
    </>
  );
};

export default DataCollection;
